import { render, staticRenderFns } from "./MinimumTaskList.vue?vue&type=template&id=02c842fe&"
import script from "./MinimumTaskList.vue?vue&type=script&lang=js&"
export * from "./MinimumTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports